export const getScrollableParent = (element: HTMLElement | null): HTMLElement | null => {
    if (!element) {
        return null;
    }

    const isOverflowHidden = element.style.overflow === 'hidden';
    const hasHorizontalScroll = element.scrollHeight > element.clientHeight;
    const hasVerticalScroll = element.scrollWidth > element.clientWidth;

    if (!isOverflowHidden && (hasHorizontalScroll || hasVerticalScroll)) {
        return element;
    }

    return getScrollableParent(element.parentElement);
};
